import { KBDocument } from '../../types';

export const sleepAndHeadaches: KBDocument = {
  id: 'placeholder-sleep-headaches',
  title: '[PLACEHOLDER] Sleep and headache frequency — general background',
  source: 'Placeholder demo content — not yet curated',
  placeholder: true,
  text: `Poor or irregular sleep is one of the most commonly reported triggers for tension-type
and migraine headaches. Both too little sleep and oversleeping relative to a person's usual
pattern have been associated with more frequent or more severe headache days in self-reported
tracking data.

Keeping a consistent sleep and wake schedule, even on weekends, is a commonly suggested
general wellness habit for people who notice their headaches cluster around nights of disrupted
sleep. This is general background information, not a diagnosis or treatment recommendation for
any individual.`
};
